var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slice && _vm.slice.hero_image && _vm.slice.hero_image.url)?_c('div',{staticClass:"banner",class:{
    'hero': _vm.hero,
    'ma-6 mx-md-0': !_vm.hero
  },style:({ backgroundImage: `url('${_vm.slice.hero_image.url}')`, width: `${_vm.slice.hero_image.dimensions.width}px`, height: `${_vm.slice.hero_image.dimensions.height}px`})},[(_vm.slice.hero_text && _vm.slice.hero_text.length)?_c('h1',{staticClass:"banner-title"},[_vm._v("\n    "+_vm._s(_vm.slice.hero_text[0].text)+"\n  ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }